import { Table, TableHead, TableRow, TableHeaderCell, TableBody, TableCell, Tag, TagSize } from 'react-magma-dom';
import { getVersions } from "../../../../src/utils";
import * as React from 'react';
export default {
  Table,
  TableHead,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  Tag,
  TagSize,
  getVersions,
  React
};